import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, OnInit, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
	CommonButtonRowWidget,
	CommonSelectFieldWidget,
	CommonTextFieldWidget
} from '@eforall/common';
import { DashboardDialogFramePart, DialogContext } from '@eforall/dashboard';
import { VolunteerSignupMentorDetails } from '@interfaces';
import { FuncService } from '../../../../services';
import { MentorSignUpEditorFields, MentorSignupEditorForm } from './mentor-sign-up-editor.form';

@Component({
	selector: 'programs-mentor-sign-up-editor-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		CommonTextFieldWidget,
		CommonSelectFieldWidget,
		CommonButtonRowWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './mentor-sign-up-editor.dialog.html'
})

export class MentorSignUpEditorDialog implements OnInit, AfterViewInit {

	public dialogRef = inject(MatDialogRef<MentorSignUpEditorDialog>);
	public dialogContext: DialogContext<VolunteerSignupMentorDetails> = inject(MAT_DIALOG_DATA);
	private func = inject(FuncService);

	public form = new MentorSignupEditorForm();
	public formSaveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('formSaveBtn');

	ngOnInit() {
		this.form.mentorSignUpData.set(this.dialogContext.data);
	}

	ngAfterViewInit(): void {
		this.form.commonForm.setSubmitButton(
			this.formSaveBtn(),
			async (values: MentorSignUpEditorFields, changed: string[]) => {

				if (!this.dialogContext.data) return;

				await this.func.volunteering.mentorSignUp.updateSignUpData({
					volunteerSignupMentorId: this.dialogContext.data.volunteerSignupMentorId,
					volunteerSignupMentorStatus: values.volunteerSignupMentorStatus,
					note: values.note,
					assignedLanguageId: values.assignedLanguageId
				});

				this.dialogRef.close();
			}
		);
	}

	revertValues() {
		this.form.commonForm.resetAll();
	}
}